import { MultiSelect, SelectOptionType } from "@aidkitorg/component-library";
import { useCallback, useMemo } from "react";
import { useLocalizedStrings } from "../../../../Localization";
import { User } from "../../types";
import { FilterWrapper } from "../../../components/FilterWrapper";

interface UserFilterProps {
  selectedUsers: string[];
  availableUsers: User[];
  onUsersChange: (users: string[]) => void;
}

export const UserFilter: React.FC<UserFilterProps> = ({
  selectedUsers,
  availableUsers,
  onUsersChange,
}) => {
  const L = useLocalizedStrings();
  const userOptions = useMemo(() => {
    return availableUsers.map(user => ({
      value: user.uid,
      label: user.userName,
    }));
  }, [availableUsers]);

  const selectedUserOptions = useMemo(() => {
    return userOptions.filter(option => selectedUsers.includes(option.value));
  }, [userOptions, selectedUsers]);

  const handleUsersChange = useCallback((selectedOptions: SelectOptionType[]) => {
    const newUsers = selectedOptions.map(option => option.value);
    onUsersChange(newUsers);
  }, [onUsersChange]);

  return (
    <FilterWrapper label={L.admin_panel.audit_logs.users}>
      <MultiSelect
        hideLabel
        label={L.admin_panel.audit_logs.users}
        description={L.admin_panel.audit_logs.select_users_description}
        options={userOptions}
        value={selectedUserOptions}
        onChange={handleUsersChange}
        placeholder={L.admin_panel.audit_logs.select_users_placeholder}
        searchable={true}
      />
    </FilterWrapper>
  );
};
